
import ListComponent from './ListComponent'

const Therapist = () => {
    return (
        <ListComponent type="therapist" />
    )
}

export default Therapist